import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CollectionDto } from '../model/collection.model';
import { environment } from '../../environments/environment';
import { HttpClientHelper } from './http-client-helper.service';
import { firstValueFrom, map, tap } from 'rxjs';
import { ConsoleLoggerService } from "./console-logger.service";
import { DispositionListItem } from '../model/disposition-list-item.model';

@Injectable({
  providedIn: 'root'
})
export class DispositionService {

  constructor(private http: HttpClient, private httpClientHelper: HttpClientHelper,
              private log: ConsoleLoggerService) {
  }

  getDispositionsByCategory(categoryId: number) {
    const url = environment.apiUrl + `/dispositions`;
    let params = this.httpClientHelper.createHttpParams();

    params = params.append('categoryId', categoryId);

    let observable = this.http.get<CollectionDto<DispositionListItem>>(url, { params: params })
      .pipe(tap(r => this.log.debug('dispositions: ', r)))
      .pipe(map(c => c.items))
    return firstValueFrom(observable);
  }


}
